import {
	FormControl,
	FormLabel,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import BrushIcon from '@mui/icons-material/Brush';
import React, { useCallback, useState } from 'react';
import { ColorControl } from 'pages/PageEditor/settingsComponents';

type TooltipProps = React.ComponentProps<typeof Tooltip>;
const TooltipForButtonGroup = Tooltip as React.FC<
	TooltipProps & { value: string }
>;

type Props = {
	setValue: (value: string) => void;
	value: string;
	label: string;
};

const BackgroundColor: React.FC<Props> = ({
	label,
	value,
	setValue
}: Props) => {
	const [mode, setMode] = useState<'fromTheme' | 'freestyle'>(
		value ? 'freestyle' : 'fromTheme'
	);

	const [lastFreestyleColor, setLastFreestyleColor] = useState(
		mode === 'freestyle' ? value : '#808080'
	);

	const onToggleChange = useCallback(
		(_: any, v: 'fromTheme' | 'freestyle') => {
			if (v) {
				setMode(v);
				setValue(v === 'freestyle' ? lastFreestyleColor : '');
			}
		},
		[lastFreestyleColor, setValue]
	);

	const onFreestyleColorChange = useCallback(
		(hexa: string) => {
			setLastFreestyleColor(hexa);
			setValue(hexa);
		},
		[setValue]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset">
			<FormLabel component="legend">{label}</FormLabel>
			<ToggleButtonGroup
				size="small"
				color="primary"
				value={mode}
				exclusive
				onChange={onToggleChange}
			>
				<TooltipForButtonGroup
					title="Fill color based on Styles"
					value="fromTheme"
				>
					<ToggleButton value="fromTheme" key="fromTheme">
						<BrushIcon />
					</ToggleButton>
				</TooltipForButtonGroup>
				<TooltipForButtonGroup title="Custom fill color" value="freestyle">
					<ToggleButton value="freestyle" key="freestyle">
						<TuneIcon />
					</ToggleButton>
				</TooltipForButtonGroup>
			</ToggleButtonGroup>
			{mode === 'freestyle' && (
				<ColorControl color={value} onChange={onFreestyleColorChange} />
			)}
		</FormControl>
	);
};

const MemoBackgroundColor = React.memo(BackgroundColor);

export { MemoBackgroundColor as BackgroundColor };
